import React from 'react'
import { List, ListItem, Paper, Popper, Input } from '@material-ui/core'
import styled from 'styled-components'

// This two imports and their use are required to avoid issues with the Material UI styles
import ReactDOMServer from 'react-dom/server'
import RedIcon from '@material-ui/icons/Cancel'

import { colors, theme } from '../../../theme/Global'

ReactDOMServer.renderToStaticMarkup(<RedIcon />)

export const StyledPopper = styled(Popper)`
  margin-top: 1rem;
  transition: opacity 0.5s;
  transition-timing-function: ease;
`

export const CompanyList = styled(List)`
  max-height: 17rem;
  overflow-y: scroll;
 `

export const CompanyListItem = styled(ListItem)`
  min-width: 34.8rem;
  color: ${theme.colors.text};
  :hover {
    background-color: ${colors.lightBlue};
  }
`

export const CustomFullPageWrapper = styled.div`
  background-color: ${theme.colors.blueBackground};
  bottom: 0;
  height: 100%;
  left: 0;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  display: flex;
  flex: 1;
`

export const CustomPaper = styled(Paper)`
  background: ${colors.white};
  margin: 5vh auto 0 auto;
  max-width: 587px;
  padding: 59px 89px;
  textAlign: center;
  width: 90%;
`

export const StyledSelectionBox = styled.div`
  padding: 1rem 0;
`

export const CompanyInput = styled(Input)`
  width: 35rem;
  padding: 14px 0 14px 5px;
  border: 1px solid;
`
